import React, { useState } from "react";
import {
  useTable,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";
import { GlobalFilter } from "./GlobalFIlter";
import { useLocation } from "react-router-dom";
import SelectValidator from "./SelectValidator";
import { getUserTypeOptions } from "../../../utils";
import { decrypt } from "../../../utils/encodingdecoding";
import { ValidatorForm } from "react-form-validator-core";

const Paginated = ({ columns, data, originalData, setFilteredData, templateList, selectedUserType, setSelectedUserType, setOrder, userOpt, setSelectedUser, selectedUser }) => {
  const {
    getTableProps,
    getTableBodyProps,
    rows,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    setPageSize,
    prepareRow,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: ["searchText"],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  const location = useLocation()
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const options = [
    { label: "Select All", value: "all" },
    ...getUserTypeOptions(decrypt(localStorage.getItem("Id")))
  ];

  const handleFilter = async (value) => {
    setSelectedUserType(value);
    setSelectedUser("")
  };

  const handlePageIndex = (event) => {
    if (event.target.value !== "") {
      const number = event.target.value ? Number(event.target.value) - 1 : 0;
      gotoPage(number);
    }
  };

  const handleTemplateFilter = (e) => {
    const value = e.target.value;
    setSelectedTemplate(value);

    if (value === "") {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        item => item.productName === value
      );
      setFilteredData(filtered);
    }
  };
  const onSubmit = () => { }

  return (
    <div className="customTable">
      <div className="customTable__header">
        <div className="customTable__left">
          <div className="customTable__showingRecords">
            <div className="form-group">
              <label>Show Records:</label>
              <select
                className="form-control selectArrow"
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                {[10, 25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="customTable__right">
          {location.pathname.includes("/channel-partner/orders") && <ValidatorForm onSubmit={onSubmit}>
            <div className="d-flex gap-2 align-items-center">
              <div style={{ minWidth: "180px" }}>
                <SelectValidator
                  placeholder="Select All"
                  className="custom-ReactSelect bordered"
                  name="type"
                  value={options.find((item) => item.value === selectedUserType)}
                  selected={selectedUserType}
                  options={options}
                  onChange={(option) => handleFilter(option.value)}
                />
              </div>

              <div style={{ minWidth: "220px" }}>
                <SelectValidator
                  placeholder="Select All"
                  className="custom-ReactSelect bordered"
                  name="user"
                  value={
                    selectedUser
                      ? userOpt?.find((item) => item.value === selectedUser)
                      : null
                  }
                  selected={selectedUser}
                  options={userOpt}
                  onChange={(opt) => setSelectedUser(opt.value)}
                />
              </div>
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
          </ValidatorForm>}

          {location.pathname.includes("qrcode-list") && <div className="form-group mt-2" >
            <select
              className="form-control selectArrow"
              value={selectedTemplate}
              onChange={handleTemplateFilter}
            >
              <option value="">Select Product</option>
              {templateList?.map((tpl, index) => (
                <option key={index} value={tpl}>
                  {tpl}
                </option>
              ))}
            </select>
          </div>}
        </div>
      </div>
      <div className="customTable__body">
        <div className="table-responsive">
          <table
            className="table table-striped table-bordered"
            {...getTableProps()}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {page?.length ? (
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={i}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell") ? cell.render("Cell") : "Null"}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={12}>
                    <p style={{ textAlign: "center", margin: 0 }}>
                      No data found
                    </p>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      <div className="customTable__footer">
        <div className="customTable__left">
          <div className="customTable__totalTransactions">
            <p>
              Total Records: <span>{rows.length}</span>
            </p>
          </div>
        </div>
        <div className="customTable__right">
          <div className="customTable__top">
            <div className="customTable__totalPages">
              <p>
                Page
                <select
                  className="form-control selectArrow"
                  value={pageIndex + 1}
                  onChange={handlePageIndex}
                >
                  {pageOptions?.length ? (
                    pageOptions.map((pageIndex) => (
                      <option key={pageIndex} value={pageIndex + 1}>
                        {pageIndex + 1}
                      </option>
                    ))
                  ) : (
                    <option key={1} value={1}>
                      {1}
                    </option>
                  )}
                </select>
                of <span>{pageOptions.length ? pageOptions.length : 1}</span>
              </p>
            </div>
          </div>
          <div className="customTable__bottom customTable__bottom__2">
            <div className="customTable__buttons">
              <span
                className="btn btn-outline-primary"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"Previous"}
              </span>
              <span
                className="btn btn-outline-primary"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {"Next"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paginated;
